import { InputProps } from '@apia/theme';
import { ValidatedCollectorField } from '../../ValidatedCollectorField';
import { Component } from './Component';
import { getLabelName, getLabelTooltip } from '@apia/util';
import { SwitchMultipleOption } from '@apia/components';

export type SwitchInputProps<T extends string> = {
  name: string;
  label?: string;
  title?: string;
  options: SwitchMultipleOption<T>[];
  formName?: string;
  initialValue?: T;
  removeOnUnmount?: boolean;
  validationFunction?: any;
  validationRules?: any;
  onChange?: (ev: T) => void;
};

export class CollectorSwitchMultiple<
  T extends string = string,
> extends ValidatedCollectorField<
  T,
  Omit<InputProps, 'name' | 'onChange'> & SwitchInputProps<T>
> {
  type = 'switchInput';

  Component = () => {
    const rules = this.useValidationRules();
    const validationFunction = this.useValidationFunction();
    const props = this.useProperties();

    return (
      <Component
        {...props}
        name={this.name}
        label={getLabelName(this.label)}
        title={getLabelTooltip(this.label)}
        initialValue={props.initialValue}
        validationRules={rules}
        validationFunction={validationFunction}
        options={props.options!}
      />
    );
  };
}
